
import Multiselect from "@/Components/General/Multiselect.vue";
import Faq from "@/types/Faq";
import {computed, defineComponent, PropType, ref, watch} from "vue";
// @ts-ignore
import MarkdownEditor from "@/Components/Forms/MarkdownEditor.vue";
import HcButton from "@/Components/Buttons/Button.vue";
import ValidationFormErrors from "@/Components/Forms/ValidationFormErrors.vue";

import {Option} from "@/types/LevelsSelectTypes";
import Checkbox from "@/Components/Controls/Checkbox.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import FaqCategory from "@/types/FaqCategory";
import {InertiaForm, useForm} from "@inertiajs/inertia-vue3";
import {Inertia} from "@inertiajs/inertia";
import Messages from "@/Components/General/Messages.vue";
import Card from "@/Components/General/Card.vue";
export default defineComponent({
  layout: AppLayout,
  components: {
    Card,
    Messages,
    Checkbox,
    HcButton,
    Multiselect,
    MarkdownEditor,
    ValidationFormErrors,
  },
  props: {
    faq: {
      type: Object as PropType<Faq>,
      required: false,
    },

    categories: {
      type: Array as PropType<FaqCategory[]>,
      required: true,
    },
    mode: {
      type: String,
      validator: (input: string) => {
        return input === "create" || input === "edit";
      },
      default: () => "create",
    },
  },
  setup(props) {
    const params = new URLSearchParams(window.location.search);

    const selectOption = (event: any, option: Option) => {
      if (Array.isArray(event)) {
        if (!option) {
          option = event[1];
        }
        event = event[0]

      }

      event.stopPropagation()
      if (option?.id !== form.faq_category_id) {
        form.faq_category_id = option?.id;
      } else {
        form.faq_category_id = null
      }

    };

    function mapCategories(categories: FaqCategory[]): Option[] {
      return categories.map((category: FaqCategory) => ({
        id: category.id,
        label: category.title,
        parent_id: category.parent_id,
        expandable: category.sub_categories && category.sub_categories.length > 0,
        options: category.sub_categories ? mapCategories(category.sub_categories) : [],
      }));
    }

    const options = mapCategories(props.categories);


    const defaultFaq = {
      id: props.faq?.id,
      title: props.faq?.title ?? "",
      description: props.faq?.description ?? "",
      faq_category_id: props.faq?.category?.id ?? null,
      is_draft: props.faq ? props.faq.is_draft : false,
    }


    const form: InertiaForm<any> = useForm<any>( defaultFaq);


    const submit = () => {
      if (props.mode === "create") {
        form.post(route("faq.store", props.faq?.id), {
          onSuccess: () => {

          }
        });
        return;
      }

      if (!props.faq) {
        return;
      }

      form.patch(route("faq.update", {faq: props.faq.id}), {
        onSuccess: () => {

        }
      });
    };

    const mediable = computed(() => {
      return {
        id: form.id,
        type: "faq",
      };
    });

    const isUploadingImages = ref(false);

    const uploadingImages = (value: boolean) => {
      isUploadingImages.value = value;
    };

    const abort = () => {

      if (props.faq && !props.faq.deleted_at) {



        return Inertia.get(route("faq.show", {faq: props.faq.id}));
      }

      Inertia.get(route("faq.index"));
    };

    const reset = () => {
      if (confirm("Alt du har fylt inn i skjema vil forsvinne. Vil du fortsette?")) {

        form.defaults(defaultFaq)
        form.reset()
      }
    }

    return {
      form,
      reset,
      abort,
      submit,
      mediable,
      uploadingImages,
      isUploadingImages,
      options,
      selectOption,
    };
  },
});
